<script>
    import Vue from 'vue'
	import * as VueGoogleMaps from 'vue2-google-maps';
    import vSelect from 'vue-select'    
    import Datepicker from 'vuejs-datepicker';
    import Timepicker from './Timepicker';
    import {it} from 'vuejs-datepicker/dist/locale'
    import {Form} from '../../helpers/Form/Form'

    if (window.googleMapsAPI) {
        Vue.use(VueGoogleMaps, {
            load: {
                key: window.googleMapsAPI,
                libraries: 'places',
            }
        });
    }

	export default {
		name: 'course-smart-modal',
        props: ['countActive'],
		components: {
			Datepicker,
			Timepicker,
            'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
            'google-map': VueGoogleMaps.Map,
            'google-marker': VueGoogleMaps.Marker,
            'v-select': vSelect			
		},
		data() {
			return {
                show_alert: false,
				locale: it,
				filteredDayNames: [],
                intervals: [
                    30, 60, 90, 120, 150, 180, 210, 240
                ],
                sport: null,
                sports: [],				
                types: ['geocode'],
				dateValidation: true,
                showDetailDays: false,
				form: new Form({
                    slug: null,
                    validation: 'enabled',
                    id: null,
                    company_id: null,
					name: null,
					address: null,
					sportId: null,
					start_age: null,
					end_age: null,
					addressComponents: null,
					latitude: null,
					longitude: null,
                    is_active: false,
					lesson_during_course_time: 1,
                    courseDates: {
                        startDate: null,
                        endDate: null,
                    },             
                    courseDays: [],       
	                global: {
	                    startTime: {
	                        hours: 14,
	                        minutes: 0
	                    },
	                    endTime: {
	                        hours: 15,
	                        minutes: 0
	                    },
	                    interval: 60
	                },					
				}),
                dayNames: [
                    {
                        dow: 0,
                        name: 'Lunedì',
                        shortName: 'L',
                        shortNameFull: 'Lun'
                    },
                    {
                        dow: 1,
                        name: 'Martedì',
                        shortName: 'M',
                        shortNameFull: 'Mar'
                    },
                    {
                        dow: 2,
                        name: 'Mercoledì',
                        shortName: 'M',
                        shortNameFull: 'Mer'
                    },
                    {
                        dow: 3,
                        name: 'Giovedì',
                        shortName: 'G',
                        shortNameFull: 'Gio'
                    },
                    {
                        dow: 4,
                        name: 'Venerdì',
                        shortName: 'V',
                        shortNameFull: 'Ven',
                    },
                    {
                        dow: 5,
                        name: 'Sabato',
                        shortName: 'S',
                        shortNameFull: 'Sab',
                    },
                    {
                        dow: 6,
                        name: 'Domenica',
                        shortName: 'D',
                        shortNameFull: 'Dom',
                    }
                ],		
                required_fields: [
                    'name',
                    'address',
                    'sportId',
                    'courseDays',
                    'courseDates',
                    'start_age',
                    'end_age'
                ]		
			}
		},
        computed: {
            disabledDates() {
                return {
                    to: new Date(this.form.courseDates.startDate)
                };
            },
        }, 
        watch: {
            'form.start_age': {
                handler(val) {
                    if (_.isNumber(val)) {
                        this.$set(this.form, 'start_age', parseInt(val))
                    }
                }
            },            
            'form.end_age': {
                handler(val) {
                    if (_.isNumber(val)) {
                        this.$set(this.form, 'end_age', parseInt(val))
                    }
                }
            },
            'form.global.interval': {
                handler(value) {
                    if (_.isNumber(value)) {
                        this.form.courseDays.forEach(d => {
                            d.interval = $.extend( {}, value );
                        })
                    }
                }
            },
            'form.global.startTime': {
                handler(value) {
                    let mStart = new moment(`${value.hours}:${value.minutes}:00`, 'HH:mm:ss')
                    let mEnd = new moment(`${this.form.global.endTime.hours}:${this.form.global.endTime.minutes}:00`, 'HH:mm:ss')

                    if (mStart.diff(mEnd, 'minutes') > 0) {
                        this.dateValidation = false;
                    } else {
                        this.dateValidation = true;
                        this.form.courseDays.forEach(d => {
                            d.startTime = $.extend( {}, value );
                        })
                    }
                },
                deep: true
            },
            'form.global.endTime': {
                handler(value) {
                    let mEnd = new moment(`${value.hours}:${value.minutes}:00`, 'HH:mm:ss')
                    let mStart = new moment(`${this.form.global.startTime.hours}:${this.form.global.startTime.minutes}:00`, 'HH:mm:ss')

                    if (mEnd.diff(mStart, 'minutes') > 0) {
                        this.dateValidation = true;
                        this.form.courseDays.forEach(d => {
                            d.endTime = $.extend( {}, value );
                        })
                    }
                },
                deep: true
            },
            'form.startDate': {
            	handler(val) {
	                if (val > this.form.endDate) {
	                    this.form.endDate = null;
	                    this.dateValidation = false;
	                } else {
	                    this.dateValidation = true;
	                }
               	}
            },
            'form.endDate': {
            	handler(val) {
	                if (this.form.startDate <= val) {
	                    this.dateValidation = true;
	                }
	            }
            },
            'form.sportId': {
            	handler(val) {
	                if (!this.sport) {
	                    this.getSport(val);
	                }
	            }
            },
            'sport': {
            	handler(val) {
	                if (val) {
	                    this.form.sportId = val.id;
	                }
	            }
            },            
        },              		
		mounted() {
            this.dayNames.forEach(d => {
                let selected = this.form.courseDays.filter(cd => cd.dow == d.dow).length > 0
                this.filteredDayNames.push(Object.assign(d, { selected }))
            })

            this.initSelect2()

            $("#course-smart-modal").on('hidden.bs.modal', () => {
                this.$set(this.form, 'courseDays', [])
                this.$set(this, 'show_alert', false)

                this.dayNames.forEach(d => {
                    let selected = this.form.courseDays.filter(cd => cd.dow == d.dow).length > 0
                    this.$set(this.filteredDayNames[d.dow], 'selected', selected)
                })

                if (this.showDetailDays) {
                    this.toggleDetails()
                }

                if (!this.form.is_active) {
                    this.form.reset()
                    $(this.$refs.sportSelect2).val('').trigger('change')
                }                
            })

            $("#course-smart-modal-confirm").modal({
                show: false,
                backdrop: 'static',
                escape: false
            })

            this.$bus.$on('course-modal.show', (payload) => {
                this.$set(this.form, 'company_id', payload.company.id)
            })

            this.$bus.$on('courses.edit', (payload) => {
                this.$set(this.form, 'id', payload.course.id)
                this.$set(this.form, 'name', payload.course.name)
                this.$set(this.form, 'slug', payload.course.slug)
                this.$set(this.form, 'address', payload.course.address)
                this.$set(this.form, 'latitude', payload.course.latitude)
                this.$set(this.form, 'longitude', payload.course.longitude)
                this.$set(this.form, 'start_age', payload.course.start_age)
                this.$set(this.form, 'end_age', payload.course.end_age)                
                this.$set(this.form, 'sportId', payload.course.sport_id)
                this.$set(this.form, 'company_id', payload.course.company_id)
                this.$set(this.form, 'lesson_during_course_time', payload.course.lesson_during_course_time)
                this.$set(this.form, 'courseDays', payload.course.days.map((i, idx) => {
                    return {
                        index: i.dow,
                        name: this.dayNames[i.dow].name,
                        shortName: this.dayNames[i.dow].shortName,
                        shortNameFull: this.dayNames[i.dow].shortNameFull,
                        validationError: false,
                        dow: i.dow,                        
                        interval: i.interval,
                        startTime: {
                            hours: parseInt(i.start_time.substr(0, 2)),
                            minutes: parseInt(i.start_time.substr(3, 2))              
                        },
                        endTime: {
                            hours: parseInt(i.end_time.substr(0, 2)),
                            minutes: parseInt(i.end_time.substr(3, 2))   
                        }
                    }
                }))
                this.$set(this.form, 'courseDates', {
                    startDate: payload.course.start_date,
                    endDate: payload.course.end_date
                })
                this.$set(this, 'sport', payload.course.sport)

                this.dayNames.forEach(d => {
                    let selected = this.form.courseDays.filter(cd => cd.dow == d.dow).length > 0
                    this.$set(this.filteredDayNames[d.dow], 'selected', selected)
                })

                if (payload.course.days.length > 0) {
                    this.form.courseDays.sort(this.compare)
                    this.$set(this.form.global, 'interval', this.form.courseDays[0].interval)
                    this.groupDaysByTime()
                }

                let endDate = moment(this.form.courseDates.endDate)
                if (endDate.isBefore()) {
                    this.form.errors.record({
                        'range_expired' : ['Periodo scaduto, aggiorna le date'],
                    })
                }
            })

            $("#course-smart-modal-confirm").on('hidden.bs.modal', () => {
                this.form.reset()
                $(this.$refs.sportSelect2).val('').trigger('change')
            })                 
		},
		methods: {
            onShowPreview() {
                location.href = route('courses.show', this.form.slug)
            },
            onShowDetail() {
                location.href = route('courses.edit', this.form.slug)
            },
            onNewCreate() {
                $("#course-smart-modal-confirm").modal('hide')
                $("#course-smart-modal").modal('show')
            },
            onClose() {
                if (_.isNull(this.form.id)) {
                    let fillData = []
                    let complete = false

                    this.required_fields.forEach(i => {
                        if (_.isObject(this.form[i])) {
                            let obj = this.form[i]
                            for (let prop in obj)  {
                                complete = !_.isNull(obj[prop])
                            }

                            if (complete) {
                                fillData.push(i)
                            }
                        } else {
                            if (_.isString(this.form[i]) || _.isNumber(this.form[i])) {
                                if (!_.isNull(this.form[i])) {
                                    fillData.push(i)
                                }
                            } else if (_.isArray(this.form[i])) {
                                if (!_.isEmpty(this.form[i])) {
                                    fillData.push(i)
                                }                                
                            }
                        }
                    })
                    console.log('fillData', fillData)

                    if (!_.isEmpty(fillData)) {
                        if (this.required_fields.length != fillData.length) {
                            this.show_alert = !this.show_alert
                        } 
                    } else {
                        this.show_alert = false
                    }
                }

                if (!this.show_alert) {
                    $("#course-smart-modal").modal('hide')
                }
            },
            groupDaysByTime() {
                let groupStartHours = []
                let groupEndHours = []
                let groupStartMinutes = []
                let groupEndMinutes = []

                this.form.courseDays.forEach(d => {
                    if (!groupStartHours.includes(d.startTime.hours)) {
                        groupStartHours.push(d.startTime.hours)
                    }
                    if (!groupEndHours.includes(d.endTime.hours)) {
                        groupEndHours.push(d.endTime.hours)
                    }
                    if (!groupStartMinutes.includes(d.startTime.minutes)) {
                        groupStartMinutes.push(d.startTime.minutes)
                    }
                    if (!groupEndMinutes.includes(d.startTime.minutes)) {
                        groupEndMinutes.push(d.endTime.minutes)
                    }
                })
                if (groupStartHours.length === 1 && groupEndHours.length === 1 && groupStartMinutes.length === 1 && groupEndMinutes.length === 1) {
                    this.$set(this.form.global, 'startTime', {
                        hours: groupStartHours[0],
                        minutes: groupStartMinutes[0]
                    })
                    this.$set(this.form.global, 'endTime', {
                        hours: groupEndHours[0],
                        minutes: groupEndMinutes[0]
                    })
                } else {
                    this.toggleDetails()
                }
            },            
            validation() {
                this.validationMessage = null;
                let endDate = moment(this.form.courseDates.endDate)
                if (endDate.isBefore()) {
                    this.form.errors.record({
                        'range_expired' : ['Periodo scaduto, aggiorna le date'],
                    })
                    return
                }

                if (this.form.courseDates.startDate > this.form.courseDates.endDate) {
                    this.validationMessage = 'Start date is later than end date';
                    this.form.errors.record({
                        'courseDates.endDate' : ['Valore non valido']
                    })
                    return false;
                }
                this.form.errors.clear()

                this.form.courseDays.forEach((day) => {
                    let startTime = new moment(`${day.startTime.hours}:${day.startTime.minutes}:00`, 'HH:mm:ss')
                    let endTime = new moment(`${day.endTime.hours}:${day.endTime.minutes}:00`, 'HH:mm:ss')
                    let duration = endTime.diff(startTime, 'minutes')

                    day.validationError = false;
                    if (this.form.global.interval != 0 && duration % this.form.global.interval != 0) {
                        day.validationError = true;
                        this.validationMessage = 'Lessons duration has not a valid interval time';
                    }
                    if (day.startTime.hours === null || day.endTime.minutes === null || day.startTime.hours > day.endTime.hours) {
                        day.validationError = true;
                        this.validationMessage = day.name + ' is invalid.';
                    }
                    else if (day.startTime.hours === day.endTime.hours && day.startTime.minutes >= day.endTime.minutes) {
                        day.validationError = true;
                        this.validationMessage = day.name + ' is invalid.';
                    }
                });
                if (this.validationMessage) {
                    if (!this.showDetailDays) {
                        this.toggleDetails()
                    }
                }
            },       
            toggleDetails() {
                this.showDetailDays = !this.showDetailDays
            },                
			initSelect2() {
				let vm = this

	            $(this.$refs.sportSelect2).select2({
	                ajax: {
	                    url: route('api.sports'),
	                    delay: 500,
	                    data: function (params) {
	                        return {
	                            'q': params.term
	                        }
	                    },
	                    processResults: function (data) {
	                        var results = [];

	                        vm.$set(vm, 'sports', data.sports)
	                        data.sports.forEach(function (a, b) {
	                            results.push({
	                                'id': a.id,
	                                'text': a.name
	                            })
	                        })
	                        // Transforms the top-level key of the response object from 'items' to 'results'
	                        return {
	                            results: results
	                        };
	                    }
	                }            	
	            });

	            $(this.$refs.sportSelect2).on('change', function (event) {
	            	let selected = $(this).select2('data')[0];

                    if (_.isObject(selected)) {
    	            	vm.$set(vm.form, 'sportId', selected.id)
	                   	vm.$set(vm, 'sport', _.head(vm.sports.filter(i => i.id == selected.id)))
                    }
	            })	            
			},
            getAddressData(payload) {
                this.form.address = payload.formatted_address;
                this.form.addressComponents = payload.address_components;
                this.form.latitude = payload.geometry.location.lat();
                this.form.longitude = payload.geometry.location.lng();
            },			
            dateFormatter(date) {
                return moment(date).format('DD/MM/YYYY', 'it');
            },
            dayIsSelected(dow) {
                return this.form.courseDays.filter(d => d.dow == dow).length > 0
            },
            addTimeSlot(day) {
                let time = {
                    index: day.index,
                    name: day.name,
                    dow : day.dow,
                    shortName: day.shortName,
                    shortNameFull: day.shortNameFull,
                    validationError: false,
                    startTime: $.extend( {}, day.startTime ),
                    endTime: $.extend( {}, day.endTime )
                }
                this.form.courseDays.push(time);
                this.form.courseDays.sort(this.compare)
            },            
            addTime(day, index) {
                if (!this.filteredDayNames[day.dow].selected) {
                    this.$set(this.filteredDayNames[day.dow], 'selected', true)
                    let time = {
                        index: index,
                        name: day.name,
                        dow : day.dow,
                        shortName: day.shortName,
                        shortNameFull: day.shortNameFull,
                        validationError: false,
                        startTime: this.form.global.startTime,
                        endTime: this.form.global.endTime
                    }
                    this.form.courseDays.push(time);
                    this.form.courseDays.sort(this.compare)
                } else {
                    this.removeAllTime(day.dow)
                }
            },
            removeAllTime(dow) {
                let courseDays = this.form.courseDays.filter(d => d.dow != dow);
                this.$set(this.filteredDayNames[dow], 'selected', false)
                this.$set(this.form, 'courseDays', courseDays)
            },
            removeTime(dow, index) {
                this.form.courseDays.splice(index, 1);

                let d_index  = this.form.courseDays.map(function (day) { return day.dow; }).indexOf(dow);
                if (!d_index) {
                    this.$set(this.filteredDayNames[dow], 'selected', false)
                }
            },   
            getStartTimeId(day) {
                return Math.random() + 'start' + day.dow
            },
            getEndTimeId(day) {
                return Math.random() + 'end' + day.dow
            },
            getSport(sportId) {
                var self = this;

                axios({
                    method: 'get',
                    url: '/sports/' + sportId
                }).then((response) => {
                    this.sport = response.data.sport;

                }).catch((error) => {
                    self.message = 'Error';
                });
            },  
            compare(a, b) {
                if (a.index < b.index)
                    return -1;
                if (a.index > b.index)
                    return 1;
                return 0;
            },       
            async onSubmit(showModals = true) {
                if (this.form.validation == 'enabled') {
                    this.validation()

                    if (!_.isEmpty(this.validationMessage)) {
                        return
                    }
                }

                this.setCourseComplete()

            	await this.form
            		.submit('post', route('courses.smart_store'))
            		.then(response => {
                        if (_.isNull(this.form.id)) {
                            window.alerts.success('Corso creato correttamente');

                            this.$bus.$emit('course.created', response)

                            this.$set(this.form, 'slug', response.course.slug)
                        } else {
                            window.alerts.success('Corso modificato correttamente');

                            this.$bus.$emit('course.updated', response)
                        }

                        if (showModals) {
                            $("#course-smart-modal").modal('hide')
                            if (this.form.is_active) {
                                $("#course-smart-modal-confirm").modal('show')
                            }
                        }

                        $(this.$refs.sportSelect2).val('').trigger('change')
                        this.$set(this, 'show_alert', false)
                        this.$set(this.form, 'validation', 'enabled')
            		})
                    .catch(error => this.$set(this, 'show_alert', false))
            },
            setCourseComplete() {
                this.show_alert = false

                if (_.isNull(this.form.id)) {
                    let fillData = []
                    let complete = false

                    this.required_fields.forEach(i => {
                        if (_.isObject(this.form[i])) {
                            let obj = this.form[i]
                            for (let prop in obj)  {
                                complete = !_.isNull(obj[prop])
                            }

                            if (complete) {
                                fillData.push(i)
                            }
                        } else {
                            if (_.isString(this.form[i]) || _.isNumber(this.form[i])) {
                                if (!_.isNull(this.form[i])) {
                                    fillData.push(i)
                                }
                            } else if (_.isArray(this.form[i])) {
                                if (!_.isEmpty(this.form[i])) {
                                    fillData.push(i)
                                }                                
                            }
                        }
                    })

                    if (!_.isEmpty(fillData)) {
                        if (this.required_fields.length != fillData.length) {
                            this.show_alert = !this.show_alert
                        } 
                    } else {
                        this.show_alert = false
                    }
                }

                this.$set(this.form, 'is_active', !this.show_alert)
            },
            onForceSubmit() {
                this.$set(this.form, 'validation', 'disabled')

                this.onSubmit()
            },
            async onRedirectAfterSubmit() {
                await this.form
                    .submit('post', route('courses.smart_store'))
                    .then(response => {
                        this.onShowDetail()
                    })
                    .catch(error => this.$set(this, 'show_alert', false))
            }                   		
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseSmartModal.vue